let regex = /^.+$/;
export function linkRemoteRegexGet() {
    return regex;
}
export function linkRemoteRegexSet(value) {
    const previous = regex;
    regex = value;
    return previous;
}
export { linkRemoteRegexGet as get, linkRemoteRegexSet as set };
//# sourceMappingURL=regex.js.map